// components/Header.js

/*
Uslov da bismo uspešno obavili kupoprodaju je da imaš navršenih 18 godina i da poseduješ važeći dokument sa fotografijom izdat u republici Srbiji (lična karta, pasoš ili vozačka dozvola). Tvoje podatke evidentiramo u skladu sa važećim zakonima republike Srbije.

Ukoliko ste van Obrenovca, prilikom kupoprodaje mi pokrivamo vase troskove putovanja (gorivo).
Troškove goriva nadoknađujemo samo ako saradnja bude realizovana

Kako bismo obezbedili najbolju uslugu i tačnu procenu vrednosti Vaših dragocenosti, otkup obavljamo isključivo u našoj radnji.
Molimo Vas da donosite predmete lično, jer samo na taj način možemo garantovati sigurnost i pokrivanje svih troškova procene.

Ko nije u mogucnosti da dodje do radnje moze slanje paketa i dobija novac na racun.
Prilikom preuzimanja dobija uplatu na racun.

Hvala na razumevanju i poverenju!

Nadoknada troškova puta
Da bismo našim klijentima izašli u susret, nadoknađujemo troškove goriva svima koji dolaze kod nas, a koji stanuju van Obrenovca, ukoliko saradnja bude realizovana.
Na ovaj način želimo da pokažemo ozbiljnost i poštovanje prema vremenu i izdacima naših klijenata.

Način saradnje
Ukoliko nismo u mogućnosti da se lično vidimo i obavimo razmenu uživo, saradnju radim isključivo putem pošiljke.
Paket mi stiže na adresu, pregledam sadržaj i odmah nakon toga vršim uplatu na račun prodavca.
Ovaj princip koristim isključivo zbog sigurnosti i izbegavanja mogućih prevara.

+381 60 5809797 - whatsapp i viber


GDE SE NALAZIMO:
Miloša Obrenovića 74, Obrenovac 11500

igormilenkovic2001@gmail.com
otkuptrevia@gmail.com


 */

import React, { useState, useEffect } from 'react';
import styles from './Header.module.scss';
import logo from '../../LOGO-removebg-preview.png'
import {motion, AnimatePresence} from "framer-motion";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // ... existing code ...
  const handleCopyPhone = async () => {
    const phone = '+381 60 5809797';
    try {
      await navigator.clipboard.writeText(phone);
      setCopied(true);
      setTimeout(() => setCopied(false), 1600);
    } catch (_) {
      const textarea = document.createElement('textarea');
      textarea.value = phone;
      document.body.appendChild(textarea);
      textarea.select();
      try { document.execCommand('copy'); } finally {
        document.body.removeChild(textarea);
        setCopied(true);
        setTimeout(() => setCopied(false), 1600);
      }
    }
  };

  return (
    <header className={`${styles.header} ${isScrolled ? styles.scrolled : ''}`}>
      <div className={styles.topBar}>
        <div className={styles.container}>
          <div className={styles.logo} onClick={() => { window.location.href = '/'; }}>
            {/*TREVIA<span>®</span>*/}
            <img src={logo} alt="logo" className={styles.logoImg} />
          </div>
          {/*<nav className={styles.nav}>*/}{/* ... existing code ... */}{/*</nav>*/}
          <div className={styles.actions}>
            <button className={styles.phoneBtn} onClick={handleCopyPhone} aria-label="Kopiraj broj telefona">
              <i className="fas fa-phone"></i>
              <span>+381 60 5809797</span>
            </button>
          </div>
        </div>
      </div>

      {/* Popup sa ulazom s desne strane i izlazom nazad u desno (x = 200) */}
      <AnimatePresence>
        {copied && (
          <motion.div
            key="copy-toast"
            initial={{ opacity: 1, x: 200, scale: 0.9 }}
            animate={{ opacity: 1, x: 0, scale: 1 }}
            exit={{ opacity: 1, x: 200, scale: 0.9 }}
            transition={{ duration: 0.35, ease: 'easeInOut' }}
            style={{
              position: 'fixed',
              top: '26px',
              right: '10px',
              background: 'green',
              color: '#fff',
              padding: '10px 47px',
              borderRadius: '8px',
              boxShadow: '0 6px 18px rgba(0,0,0,0.2)',
              zIndex: 2000,
              fontSize: '0.95rem'
            }}
            role="status"
            aria-live="polite"
          >
            Broj kopiran!
          </motion.div>
        )}
      </AnimatePresence>

      {/*<div className={styles.hero}>*/}{/* ... existing code ... */}{/*</div>*/}
    </header>
  );
};

export default Header;